package com.karyadina.ui.screens.flashcards.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.karyadina.model.ExamType

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AddSubjectDialog(
    onDismiss: () -> Unit,
    onAdd: (String, ExamType, String) -> Unit
) {
    var name by remember { mutableStateOf("") }
    var selectedExamType by remember { mutableStateOf(ExamType.GATE) }
    var selectedColor by remember { mutableStateOf("#4CAF50") }
    var expandedExamType by remember { mutableStateOf(false) }
    
    val colorOptions = listOf(
        "#4CAF50", // Green
        "#2196F3", // Blue
        "#FF9800", // Orange
        "#9C27B0", // Purple
        "#F44336", // Red
        "#00BCD4", // Cyan
        "#FFC107", // Amber
        "#E91E63"  // Pink
    )
    
    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text("Add New Subject") },
        text = {
            Column(
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                OutlinedTextField(
                    value = name,
                    onValueChange = { name = it },
                    label = { Text("Subject Name") },
                    placeholder = { Text("e.g., Mathematics, Physics") },
                    singleLine = true,
                    modifier = Modifier.fillMaxWidth()
                )
                
                // Exam Type Selector
                ExposedDropdownMenuBox(
                    expanded = expandedExamType,
                    onExpandedChange = { expandedExamType = it }
                ) {
                    OutlinedTextField(
                        value = selectedExamType.displayName,
                        onValueChange = {},
                        readOnly = true,
                        label = { Text("Exam Type") },
                        trailingIcon = {
                            ExposedDropdownMenuDefaults.TrailingIcon(expanded = expandedExamType)
                        },
                        modifier = Modifier
                            .fillMaxWidth()
                            .menuAnchor()
                    )
                    
                    ExposedDropdownMenu(
                        expanded = expandedExamType,
                        onDismissRequest = { expandedExamType = false }
                    ) {
                        ExamType.entries.forEach { examType ->
                            DropdownMenuItem(
                                text = { Text(examType.displayName) },
                                onClick = {
                                    selectedExamType = examType
                                    expandedExamType = false
                                }
                            )
                        }
                    }
                }
                
                // Color Picker
                Text(
                    "Choose Color",
                    style = MaterialTheme.typography.labelMedium
                )
                
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceEvenly
                ) {
                    colorOptions.forEach { color ->
                        Box(
                            modifier = Modifier
                                .size(40.dp)
                                .clip(CircleShape)
                                .background(com.karyadina.ui.theme.StudyTheme.parseHexColor(color))
                                .border(
                                    width = if (color == selectedColor) 3.dp else 0.dp,
                                    color = MaterialTheme.colorScheme.primary,
                                    shape = CircleShape
                                )
                                .clickable { selectedColor = color }
                        )
                    }
                }
            }
        },
        confirmButton = {
            Button(
                onClick = {
                    if (name.isNotBlank()) {
                        onAdd(name, selectedExamType, selectedColor)
                    }
                },
                enabled = name.isNotBlank()
            ) {
                Text("Add")
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text("Cancel")
            }
        }
    )
}
